module.exports = __webpack_public_path__ + "static/media/background-especiais.c90640d4.webp";